export default {
  'menu.workbench': '歡迎',
  'menu.more-blocks': '更多區塊',
  'menu.home': '首頁',
  'menu.admin': '权限',
  'menu.admin.sub-page': '二级管理页',
  'menu.permissions': '權限管理',
  'menu.talent-review': '人才盤點',
  'menu.talent-review.workbench': '盤點工作臺',
  'menu.talent-review.cycles': '週期管理',
  'menu.talent-review.participants': '名單核定',
  'menu.talent-review.scoring': '評分錄入',
  'menu.talent-review.results': '結果校驗',
  'menu.talent-review.dashboard': '基礎看板',
  'menu.talent-review.job-profiles': '崗位畫像',
  'menu.talent-review.fit-analysis': '適配分析',
  'menu.talent-review.reports': '盤點報告',
  'menu.talent-review.employee-detail': '員工詳情',
  'menu.talent.list': '人才檔案',
  'menu.talent.detail': '人才詳情',
  'menu.review.grid': '人才盤點',
  'menu.interview': '人才訪談',
  'menu.interview.session': '訪談執行',
  'menu.pool': '人才庫',
  'menu.insights': '組織洞察',
  'menu.development.plan': '發展計劃',
  'menu.succession': '繼任計劃',
  'menu.settings.tags': '標籤配置',
  'menu.settings.model': '能力模型配置',
  'menu.settings.grid': '九宮格模型配置',
  'menu.login': '登錄',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析頁',
  'menu.dashboard.monitor': '監控頁',
  'menu.dashboard.workplace': '工作臺',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表單頁',
  'menu.form.basic-form': '基礎表單',
  'menu.form.step-form': '分步表單',
  'menu.form.step-form.info': '分步表單（填寫轉賬信息）',
  'menu.form.step-form.confirm': '分步表單（確認轉賬信息）',
  'menu.form.step-form.result': '分步表單（完成）',
  'menu.form.advanced-form': '高級表單',
  'menu.list': '列表頁',
  'menu.list.table-list': '查詢表格',
  'menu.list.basic-list': '標淮列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（項目）',
  'menu.list.search-list.applications': '搜索列表（應用）',
  'menu.profile': '詳情頁',
  'menu.profile.basic': '基礎詳情頁',
  'menu.profile.advanced': '高級詳情頁',
  'menu.result': '結果頁',
  'menu.result.success': '成功頁',
  'menu.result.fail': '失敗頁',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '個人頁',
  'menu.account.center': '個人中心',
  'menu.account.workbench': '返回工作臺',
  'menu.account.tenantManagement': '企業管理',
  'menu.account.trigger': '觸發報錯',
  'menu.account.logout': '退出登錄',
  'menu.editor': '圖形編輯器',
  'menu.editor.flow': '流程編輯器',
  'menu.editor.mind': '腦圖編輯器',
  'menu.editor.koni': '拓撲編輯器',
};
